import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// import { EventService } from 'app/modules/events/services/event.service';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { PanelMenuModule } from 'primeng/panelmenu';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../../../app.layout.service';
import { AppIcons } from '../../app.icons';
import { Country } from '../../models/country';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { ConfigService } from '../../services/config.service';
import { EntityService } from '../../services/entity.service';
import { MetaDataService } from '../../services/meta-data.service';
import { PermissionAccessService } from '../../services/permission-access.service';
import { AppSettings } from './../../app.settings';
import { MenuAccess } from './mdoal/sidebarModal';
import { ButtonModule } from 'primeng/button';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [PanelMenuModule, DropdownModule, FormsModule, TranslateModule, ReactiveFormsModule, ButtonModule]
})
export class SidebarComponent implements OnInit {
  @ViewChild(Dropdown) dropdown: Dropdown;
  @Output() isReadySidebar: EventEmitter<boolean> = new EventEmitter();
  @Input() items: MenuItem[] = [];
  @Input() eventResponse;
  subscription: Subscription;
  selectedEventData: any;
  miIcons = AppIcons;
  listColumns: any[] = [];
  entityData: any = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    defaultSortColumn: 'updatedAt',
    defaultSortType: 'asc',
    status: 'Both',
    startDate: 1704067200000,
    endDate: 0
  };
  selectedEvent: any;
  menuConfigPermission;
  defaultIconUrl: string = '/assets/images/mi-theme/light/booking/outstation.svg';
  defaultEventImageUrl = '../../../../../assets/images/mi-theme/light/calendar/calendar_event.svg';
  eventDropdownForm: FormGroup;
  selectedEventTimezoneId: any;
  public appVersion = this.versionService.version;
  isSidebarBodyReady: boolean = false;
  // openLogo: any = "../../../../../../assets/images/mi-theme/light/nav/akesa_open_logo.png";
  // closedLogo: any = "../../../../../../assets/images/mi-theme/light/nav/akesa_closed_logo.png";
  openLogo: any = "../../../../../../assets/images/mi-theme/light/nav/clincor_open.png";
  closedLogo: any = "../../../../../../assets/images/mi-theme/light/nav/clincor_closed.png";
  closeIcon: any = "../../../../../../assets/images/mi-theme/light/nav/logo_close.png";

  akesaLogo: any = "../../../../../../assets/images/mi-theme/light/nav/akesalogo.svg";
  akesaSmallLogo: any = "../../../../../../assets/images/mi-theme/light/nav/akesasmall.svg";

  menuLinkMap = {
    DASHBOARD: { icon: AppIcons.DASHBOARD, routerLink: ['/app/dashboard'] },
    CHANGE_REVIEW: { icon: AppIcons.CHANGE_REVIEW, routerLink: ['/app/change-review'] },
    PRODUCTS: { icon: AppIcons.PRODUCT, routerLink: ['/app/products'] },
    SITES: { icon: AppIcons.SITE, routerLink: ['/app/sites'] },
    ORDERS: { icon: AppIcons.ORDER, routerLink: ['/app/orders'] },
    PROTOCOLS: { icon: AppIcons.TRIAL, routerLink: ['/app/trials'] },
    ORDER_ERP: { icon: AppIcons.ORDER, routerLink: ['/app/order-erp'] },
    DISPATCH: { icon: AppIcons.USERS, routerLink: ['/app/users'] },
    REPORTS: { icon: AppIcons.REPORT, routerLink: ['/app/reports'] },
    AKSYS_REPORT: { icon: AppIcons.AKSYS_REPORT, routerLink: ['/app/reports/aksys'] },
    MYOB_REPORT: { icon: AppIcons.MYOB_REPORT, routerLink: ['/app/reports/myob'] },
    PATIENTS: { icon: AppIcons.PATIENT, routerLink: ['/app/patients'] },
    SPONSORS: { icon: AppIcons.SPONSOR, routerLink: ['/app/sponsors'] },
    USERS_AND_ROLES: { icon: AppIcons.USER_SIDEBAR, routerLink: ['/app/manage-users'] },
    AUDIT_LOGS: { icon: AppIcons.AUDIT_LOGS, routerLink: ['/app/audit-logs'] },
    INVOICES: { icon: AppIcons.INVOICE_ICON, routerLink: ['/app/invoices'] },
    CONCERNS: { icon: AppIcons.CONCERNS, routerLink: ['/app/concerns'] },
    SHIFT_MANAGEMENT: { icon: AppIcons.CONCERNS, routerLink: ['/app/concerns'] },
  };

  country: Country;
  menuConfig: any = null;
  homeLink: string = '/app/dashboard';
  constructor(
    private commonService: CommonBindingDataService,
    public layoutService: LayoutService,
    private permissionAccessService: PermissionAccessService,
    private entityService: EntityService,
    private configService: ConfigService,
    // private eventService: EventService,
    private formBuilder: FormBuilder,
    private router: Router,
    private metaDataService: MetaDataService,
    private confirmationService: ConfirmationService,
    private versionService: VersionService
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.menuConfig = this.permissionAccessService.menuConfig;
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.homeLink = this.configService.getHomeRoute();
    this.getPermissionList();
    this.loadEvents();
    // this.eventService.eventAdded$.subscribe(res => {
    //   if (res) {
    //     this.loadEvents();
    //   }
    // })
  }

  initializeForm() {
    this.eventDropdownForm = this.formBuilder.group({
      eventDropdown: [],
    });

  }

  navigateTo(url: string): void {
    window.open(url, '_blank');
  }

  getPermissionList() {
    this.permissionAccessService.getPermissionList().subscribe((res: any[]) => {
      if (res) {
        this.menuConfigPermission = this.permissionAccessService.convertMenuConfig(res);
        this.permissionAccessService.setMenuConfig(this.menuConfigPermission);
        this.setupSidebar(res);
      }
    });
  }

  private setupSidebar(menus): void {
    const sortedData = this.getSortedMenus(menus);
    this.items = this.buildMenuItems(sortedData);
    this.isReadySidebar.emit(true);
    this.isSidebarBodyReady = true;
  }

  private getSortedMenus(menus: MenuAccess[]): MenuAccess[] {
    return _.sortBy(menus, [
      menu => parseInt(menu.orderIndex),
      menu => _.map(menu.pages, page => parseInt(page.orderIndex))
    ]).map(menu => ({
      ...menu,
      pages: _.sortBy(menu.pages, page => parseInt(page.orderIndex))
    }));
  }

  private buildMenuItems(menus: MenuAccess[]): MenuItem[] {
    const isSiteUser = this.configService.isSiteUser();
    return menus
      .filter(menu => this.menuLinkMap[menu.menuCode])
      .filter(menu => !(isSiteUser && menu.menuCode === 'DASHBOARD'))
      .map(menu => {
        const menuItem = {
          ...menu,
          icon: this.menuLinkMap[menu.menuCode]?.icon,
          routerLink: this.menuLinkMap[menu.menuCode]?.routerLink,
          items: menu.subMenus ? this.buildMenuItems(menu.subMenus) : undefined,
        };

        // Special handling for Reports menu - add MYOB and AKSYS as submenus
        if (menu.menuCode === 'REPORTS') {
          const reportSubmenus = [
            {
              label: 'MYOB Report',
              icon: this.menuLinkMap.MYOB_REPORT?.icon,
              routerLink: this.menuLinkMap.MYOB_REPORT?.routerLink
            },
            {
              label: 'Order Report',
              icon: this.menuLinkMap.AKSYS_REPORT?.icon,
              routerLink: this.menuLinkMap.AKSYS_REPORT?.routerLink
            }
          ];

          // Add existing submenus if any, then add report submenus
          menuItem.items = menuItem.items ? [...menuItem.items, ...reportSubmenus] : reportSubmenus;
        }

        return menuItem;
      })
      .filter(menu => {
        // Filter out MYOB_REPORT and AKSYS_REPORT from top-level menu since they're now under Reports
        return menu.menuCode !== 'MYOB_REPORT' && menu.menuCode !== 'AKSYS_REPORT';
      });
  }

  getTruncatedEventName(eventName: string): string {
    if (!eventName) return '';
    if (eventName.length > 16) {
      return `${eventName.slice(0, 16)}...`;
    }
    return eventName;
  }

  loadEvents() {
    // this.eventService.getUserEvents(requestBody).subscribe((result: any) => {
    //   this.listColumns = [];
    //   this.listColumns = result;
    //   const eventData = JSON.parse(localStorage.getItem('eventCodeData'));
    //   const eventCode = eventData ? eventData : null;
    //   if (eventCode) {
    //     this.selectedEvent = eventData;
    //     this.eventService.setSelectedEventData(eventData);
    //     this.eventDropdownForm.controls['eventDropdown'].setValue(eventData);
    //   } else {
    //     const hasListColumns = this.listColumns.length > 0;
    //     if (hasListColumns) {
    //       const firstEvent = this.listColumns[0];
    //       this.selectedEvent = firstEvent?.eventShortcode;
    //       const selectedEventId = firstEvent?.eventId;
    //       this.eventService.setSelectedEventData(this.selectedEvent);
    //       this.eventService.setSelectedEventId(selectedEventId);
    //       this.eventService.setSelectedEventTimeZoneId(firstEvent?.timezoneId);
    //       this.eventDropdownForm.controls['eventDropdown'].setValue(this.selectedEvent);
    //       this.selectedEventTimezoneId = firstEvent?.timezoneId;
    //     }
    //   }
    //   this.selectedEventData = this.listColumns.find(ele => ele.eventShortcode === this.selectedEvent);
    //   this.selectedEventTimezoneId = this.selectedEventData?.timezoneId;
    //   this.getTimezoneOfSelectedEvent();
    // })
  }

  onEventChangeChange() {
    // this.confirmationService.confirm({
    //   header: this.commonService.getLabel('events.confirmation'),
    //   message: this.commonService.getLabel('events.event_change_confirmation_msg'),
    //   acceptIcon: 'none',
    //   rejectIcon: 'none',
    //   acceptLabel: this.commonService.getLabel('events.lbl_yes'),
    //   rejectLabel: this.commonService.getLabel('events.lbl_no'),
    //   rejectButtonStyleClass: 'bg-white text-color',
    //   acceptButtonStyleClass: 'bg-red-500',
    //   accept: () => {
    //     this.eventService.setSelectedEventData(event.value);
    //     this.selectedEvent = event.value;
    //     this.selectedEventData = this.listColumns.find(ele => ele.eventShortcode === this.selectedEvent);
    //     const selectedEventId = this.listColumns.find(ele => ele.eventShortcode === this.selectedEvent)?.eventId;
    //     this.selectedEventTimezoneId = this.listColumns.find(ele => ele.eventShortcode === this.selectedEvent)?.timezoneId;
    //     this.eventService.setSelectedEventId(selectedEventId);
    //     this.eventService.setSelectedEventTimeZoneId(this.selectedEventTimezoneId);
    //     this.getTimezoneOfSelectedEvent();
    //     this.router.navigate(['app/dashboard'])
    //     .then(() => {
    //       window.location.reload();
    //     });
    //   },
    //   reject: () => {
    //     const eventCode = JSON.parse(localStorage.getItem('eventCodeData'));
    //     this.eventDropdownForm.controls['eventDropdown'].setValue(eventCode);
    //   }
    // });
  }

  getTimezoneOfSelectedEvent() {
    // this.entityService.getTimeZones(requestBody, false).subscribe((res: any) => {
    //   const gmtTImezone = res[0].gmtOffset;
    //   this.metaDataService.gmtOffsetTimezone.next(gmtTImezone);
    //   if (res && res.length > 0) {
    //     const element = document.getElementById('timezone');
    //     if (element) {
    //       element.innerHTML = `Current Timezone - ${res[0].timezone}`;
    //       this.metaDataService.selectedTimezoneSubject.next(res[0].timezone);
    //     }
    //   }
    // })
  }

  onDropdownMouseLeave() {
    if (this.dropdown && this.dropdown.overlayVisible) {
      this.dropdown.overlayVisible = false;
    }
  }

}
